var agp = agp || {};

agp.sitefooter = (function() {

	function init() {

		if ($("body").hasClass("edit-mode"))
			return;

		var siteFooterHeight = $(".site-footer").outerHeight(true);
		$(".site-main").css("min-height", "calc(100vh - " + siteFooterHeight + "px)")
	}

	return {
		init: init
	};

}());